<div class="download-audit-report-dialog">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>Download Company List of Audit Reports</span>
    <button mat-icon-button mat-dialog-close type="button" aria-label="Close" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="report-dialog-content">
    <p class="dialog-description">
      Download the company list of audit reports. Select a date range to include and where the generated report should be sent.
    </p>
    <form [formGroup]="form" class="dialog-form" fxLayout="column" fxLayoutGap="16px">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Pick a Date Range</mat-label>
        <mat-date-range-input [max]="maxDate" [rangePicker]="picker" formGroupName="dateRange" (click)="openDatepicker(picker)">
          <input matStartDate placeholder="Start Date" formControlName="startDate">
          <input matEndDate placeholder="End Date" formControlName="endDate">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="example-chip-list w-100" appearance="outline">
        <mat-label>Enter Email ID's (Up to 25)</mat-label>
        <mat-chip-grid #chipList formControlName="emailListControl">
          @for (email of emailList; track email) {
            <mat-chip-row (removed)="removeEmail(email)">
              {{ email }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
          <input placeholder="Enter Email" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addEmail($event)" />
        </mat-chip-grid>
        <mat-hint>Press Enter or comma to add each email</mat-hint>
        @if (form.get('emailListControl').hasError('invalidEmail')) {
          <mat-error>
            Invalid email format
          </mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
    <button mat-button type="button" (click)="onClose()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!isFormValid()" (click)="onSave()">Submit</button>
  </mat-dialog-actions>
</div>